"use client";

import Link from "next/link";
import { CalendarFestival } from "@/lib/api";
import Badge from "@ishvaram/ui/Badge";
import { getTypeColor, formatDateShort } from "./types";

interface FestivalCardProps {
  festival: CalendarFestival;
}

export function FestivalCard({ festival }: FestivalCardProps) {
  const colors = getTypeColor(festival.type);

  return (
    <Link
      href={`/calendar/festival/${festival.id}/`}
      className={`block p-4 rounded-xl border transition-all hover:shadow-md hover:scale-[1.01] active:scale-[0.99] ${colors.bg} ${colors.border}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex flex-wrap items-center gap-2 mb-2">
            <Badge
              label={festival.type.charAt(0).toUpperCase() + festival.type.slice(1)}
              variant={
                festival.type === "vrat"
                  ? "success"
                  : festival.type === "festival"
                    ? "warning"
                    : "accent"
              }
            />
            {festival.fasting && <Badge label="Fasting" variant="error" />}
          </div>
          <h3 className="font-serif text-base font-bold text-ish-dark m-0 leading-tight">
            {festival.name_en}
          </h3>
          <p className="text-sm text-ish-text-muted mt-0.5 mb-1.5 font-medium">
            {festival.name_hi}
          </p>
          <p className="text-sm text-ish-text-muted m-0 leading-relaxed line-clamp-2">
            {festival.description_en}
          </p>
        </div>
        <div className={`text-sm font-bold whitespace-nowrap shrink-0 ${colors.text}`}>
          {formatDateShort(festival.date)}
        </div>
      </div>
    </Link>
  );
}
